import { createAsyncThunk, createSlice, createDraftSafeSelector } from '@reduxjs/toolkit';
import http from '../utils/http';
import { RootState } from './store';


export interface UserEntityReference {
    code: string;
    name: string;
}

//TODO get rid of this and use entity slice version
export interface EntityAuthorization {
    entity: UserEntityReference;
    entityUserRole: string;
    entityContactRole: string;
    reportAccess: string;
}

export interface NewUser {
    eMail: string;
    firstName: string;
    lastName: string;

    entityAuthorizations: Array<EntityAuthorization>;
    userId: string;
}

export enum UserRoleEnum {
    Admin = "ADMIN",
    EntityUser = "ENTITY_USER"
}

export enum UserEntityAuthorizationEnum {
	Editor = "EDITOR",
	ThirdParty = "THIRD_PARTY",
	Notification = "NOTIFICATION",
	None = "NONE"
}

export enum AdminUserRoleEnum {
    Admin = "ADMIN",
    UserManager = "ADMIN_USER_MANAGER",
    Reviewer = "DFS_REVIEWER",
}

export interface logerUser {
    activateDate: string;
    createDate: string;
    deprecateDate: string;
    firstName: string;
    lastName: string;
    id: number;
    lastLoginDate: string;
    login: string;
    role: string;
    status: string;
    entityAuthorizations: Array<EntityAuthorization>;
    adminRole?: AdminUserRoleEnum
}

export interface UserEntityState {
    userProfile: logerUser | null;
    selectedEntity: string | null;
    status: 'idle' | 'loading' | 'failed';
}

const initialState: UserEntityState = {
    userProfile: null,
    selectedEntity: null,
    status: "idle"
}

export const nullUser = function (n: string) {
    var result: any;
    result = {
        activateDate: "",
        createDate: "",
        deprecateDate: "",
        firstName: "",
        lastName: n,
        id: 0,
        lastLoginDate: "",
        login: "",
        role: "",
        status: "",
        entityAuthorizations: []
    };

    return result;
};

export const getAuthorization = function( user : logerUser, entityId : string ) : string {
	if( !user ) 
	{
		return UserEntityAuthorizationEnum.None;
	}
	if( user.role === UserRoleEnum.Admin ) 
	{
		return UserEntityAuthorizationEnum.Editor;
	}
	var foundEntityAuthorization = user.entityAuthorizations.find((element) => element.entity.code == entityId);

	if (foundEntityAuthorization) {
		return foundEntityAuthorization.entityUserRole;
	}
	return "";
}

export const getUserData = createAsyncThunk(
    "User/GetUserData",
    async (userId: string): Promise<logerUser | undefined> => {

            const result = await http<string, logerUser>({
                path: `/user/userData`,
                method: 'post',
                body: userId
            });
        
            return result.parsedBody;
    });

export const addAdminUser = createAsyncThunk(
    "User/AddAdminUser",
    async (newUser: NewUser): Promise<logerUser | null> => {
        try {

            const result = await http<NewUser, logerUser>({
                path: `/user/addUser`,
                method: 'post',
                body: newUser
            });
            if (result.ok && result.parsedBody) {
                return result.parsedBody;
            }
            else {
                return null;
            }
        } catch (ex) {
            return null;
        }
    });

export const equalizeName = createAsyncThunk(
    "User/EqualizeName",
    async (loginAndName: { Item1: string; Item2: string; Item3: string }): Promise<logerUser | null> => {
        try {
            const result = await http<{ Item1: string; Item2: string; Item3: string }, logerUser>({
                path: `/user/equializeName`,
                method: 'post',
                body: loginAndName
            });
            if (result.ok && result.parsedBody) {
                return result.parsedBody;
            }
            else {
                return null;
            }
        } catch (ex) {
            return null;
        }       
    });

export const userSlice = createSlice({
    name: 'User',
    initialState,
    reducers: {

    },
    extraReducers: (builder: any) => {
        builder
            .addCase(getUserData.pending, (state: any) => {
                state.status = "loading";
            })
            .addCase(getUserData.fulfilled, (state: any, action: any) => {
                if (action.payload != null) {
                    state.userProfile = action.payload;
                }
                state.status = "idle";
            })
            
            .addCase(addAdminUser.pending, (state: any) => {
                state.status = "loading";
            })
            .addCase(addAdminUser.fulfilled, (state: any, action: any) => {
                if (action.payload != null) {
                    state.userProfile = action.payload;
                }
                state.status = "idle";
            })
            .addCase(equalizeName.pending, (state: any) => {
                state.status = "loading";
            })
            .addCase(equalizeName.fulfilled, (state: any, action: any) => {
                state.status = "idle";
            })
    },

});


export const { } = userSlice.actions;

export const selectUser = (state: RootState) => state.user;


export const selectUserLogged = (state: RootState) =>
    state.user ?
        state.user.userProfile ?
            state.user.userProfile
            : null
        : null;


export const selectAuthorizedEntities = (state: RootState) =>
    state.user ?
        state.user.userProfile ?
            state.user.userProfile.entityAuthorizations ?
                state.user.userProfile.entityAuthorizations.map((auth: any) => auth.entity)
                : [] : [] : [];


export const selectUserEntityAuthorizations = createDraftSafeSelector(
    (state: RootState) => state,
    (state: any) => state.user.userProfile.entityAuthorizations ? state.user.userProfile.entityAuthorizations
        : null
)


export const selectUserRole = (state: RootState) =>
    state.user ?
        state.user.userProfile ?
            state.user.userProfile.role ?
                state.user.userProfile.role
                : null : null : null;

export const selectAdminUserRole = (state: RootState) =>
    state.user ?
        state.user.userProfile ?
            state.user.userProfile.role ?
                state.user.userProfile.adminRole ?
                    state.user.userProfile.adminRole
                : null : null : null : null;

export default userSlice.reducer;





